import { Link } from 'react-router-dom';

function PatientCenteredCare() {
  return (
    <>
      {/* Breadcrumb */}
      <div className="container py-3">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/" className="text-decoration-none" style={{ color: '#0066cc' }}>
                Home
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Patient-Centered Care
            </li>
          </ol>
        </nav>
      </div>

      {/* Hero Section */}
      <section className="py-5" style={{ backgroundColor: '#fff' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h1 className="mb-4" style={{ fontSize: '3rem', fontWeight: 'bold', fontFamily: 'Georgia, serif', color: '#1a1a1a' }}>
                Patient-Centered Care
              </h1>
              <p className="lead mb-4" style={{ fontSize: '1.25rem', lineHeight: '1.6', color: '#333' }}>
                At Tema General Hospital, a world-class team of doctors and specialists will see you in one place, at one time. They'll listen to your story, learn your goals, and work together to accurately diagnose and treat your condition so you can get back to your life as quickly as possible.
              </p>
              <a 
                href="#resources" 
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('resources')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="text-decoration-none"
                style={{ color: '#0066cc', fontSize: '1.1rem', fontWeight: '600' }}
              >
                Jump to resources to get started <i className="bi bi-arrow-down"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="ratio ratio-16x9">
                <video 
                  controls 
                  className="rounded"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  poster="/img/carousel/admin2.jpg"
                >
                  <source 
                    src="/img/video/Is This Really in Africa UGMC Will Blow Your Mind ( Most Advanced in Africa ) - Harriet The Traveller (720p, h264).mp4" 
                    type="video/mp4" 
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
            <div className="col-lg-6">
              <h2 className="mb-3" style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1a1a1a' }}>
                Why choose Tema General Hospital for care?
              </h2>
              <p className="mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.6', color: '#333' }}>
                Learn what our experts tell their own patients about choosing the best treatment.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Leading Expertise Section */}
      <section className="py-5" style={{ backgroundColor: '#fff' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 mb-4 mb-lg-0">
              <p className="text-muted mb-2" style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>
                Leading expertise
              </p>
              <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#1a1a1a', lineHeight: '1.2' }}>
                A team of experts will design your treatment plan
              </h2>
              <p className="mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.6', color: '#333' }}>
                Your Tema General Hospital care team includes the best specialists in every medical field you need, focused on you. No matter what serious or complex health challenge you're facing, you can be confident that you're receiving the most advanced care at TGH.
              </p>
              <Link to="/about-us/overview" className="text-decoration-none" style={{ color: '#0066cc', fontSize: '1rem', fontWeight: '600' }}>
                More about our expertise <i className="bi bi-arrow-right ms-1"></i>
              </Link>
            </div>
            <div className="col-lg-7">
              <img 
                src="/img/carousel/labb.jpeg" 
                alt="TGH Medical Professional" 
                className="img-fluid rounded"
                style={{ maxHeight: '500px', objectFit: 'cover', width: '100%' }}
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/800x500/0066cc/ffffff?text=TGH+Healthcare';
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Right Answers Section */}
      <section className="py-5" style={{ backgroundColor: '#fff' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 mb-4 mb-lg-0">
              <img 
                src="/img/carousel/admin2.jpg" 
                alt="TGH Patient Care" 
                className="img-fluid rounded"
                style={{ maxHeight: '500px', objectFit: 'cover', width: '100%' }}
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/800x500/0066cc/ffffff?text=TGH+Patient+Care';
                }}
              />
            </div>
            <div className="col-lg-5">
              <p className="text-muted mb-2" style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>
                The right answers, the first time
              </p>
              <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#1a1a1a', lineHeight: '1.2' }}>
                Providing peace of mind and hope
              </h2>
              <p className="mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.6', color: '#333' }}>
                Getting your diagnosis right the first time means you can start on the most effective treatment plan. We are continuously developing better tools for diagnosis and treatment, so you get answers, options, and hope where none may have existed before.
              </p>
              <Link to="/diagnostic" className="text-decoration-none" style={{ color: '#0066cc', fontSize: '1rem', fontWeight: '600' }}>
                How the process works <i className="bi bi-arrow-right ms-1"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Patient Testimonial Section */}
      <section className="py-5" style={{ backgroundColor: '#e8f4f8' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <blockquote className="mb-4" style={{ fontSize: '1.5rem', fontStyle: 'italic', color: '#1a1a1a', lineHeight: '1.6' }}>
                "I have never seen medical professionals conduct themselves like the professionals at Tema General Hospital. It was a humbling feeling to be treated with such respect and such care."
              </blockquote>
              <div className="d-flex align-items-center justify-content-center">
                <div className="rounded-circle bg-secondary me-3" style={{ width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="bi bi-person-fill text-white" style={{ fontSize: '2rem' }}></i>
                </div>
                <div className="text-start">
                  <p className="mb-0 fw-bold" style={{ color: '#1a1a1a' }}>Patient Testimonial</p>
                  <p className="mb-0 text-muted">TGH Patient</p>
                </div>
              </div>
              <Link to="/contact" className="text-decoration-none d-inline-block mt-4" style={{ color: '#0066cc', fontSize: '1rem', fontWeight: '600' }}>
                Read patient stories <i className="bi bi-arrow-right ms-1"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Compassionate Experience Section */}
      <section className="py-5" style={{ backgroundColor: '#fff' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 mb-4 mb-lg-0">
              <p className="text-muted mb-2" style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>
                A compassionate, human experience
              </p>
              <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#1a1a1a', lineHeight: '1.2' }}>
                Focused on creating a plan that works for you
              </h2>
              <p className="mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.6', color: '#333' }}>
                A team of specialists will thoroughly and carefully evaluate your condition and work together to create a customized plan to meet your goals. Our team approach makes your experience less complicated, so you can focus on getting better.
              </p>
              <Link to="/general-care" className="text-decoration-none" style={{ color: '#0066cc', fontSize: '1rem', fontWeight: '600' }}>
                What our patients say about us <i className="bi bi-arrow-right ms-1"></i>
              </Link>
            </div>
            <div className="col-lg-7">
              <img 
                src="/img/carousel/recoveryy.png" 
                alt="TGH Healthcare Team" 
                className="img-fluid rounded"
                style={{ maxHeight: '500px', objectFit: 'cover', width: '100%' }}
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/800x500/0066cc/ffffff?text=TGH+Healthcare+Team';
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Innovation Section */}
      <section className="py-5" style={{ backgroundColor: '#fff' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 mb-4 mb-lg-0">
              <img 
                src="/img/carousel/labourward.JPG" 
                alt="TGH Research" 
                className="img-fluid rounded"
                style={{ maxHeight: '500px', objectFit: 'cover', width: '100%' }}
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/800x500/0066cc/ffffff?text=TGH+Research';
                }}
              />
            </div>
            <div className="col-lg-5">
              <p className="text-muted mb-2" style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>
                Innovation to impact, faster
              </p>
              <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#1a1a1a', lineHeight: '1.2' }}>
                Turning scientific discoveries into patient care
              </h2>
              <p className="mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.6', color: '#333' }}>
                Tema General Hospital patients are often the first to benefit from our research. Right now, our doctors are working on clinical studies, researching new treatments and therapies for the world's most challenging and complex medical issues.
              </p>
              <Link to="/about-us/overview" className="text-decoration-none" style={{ color: '#0066cc', fontSize: '1rem', fontWeight: '600' }}>
                More about research <i className="bi bi-lightbulb ms-1"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Resources Section */}
      <section id="resources" className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#1a1a1a' }}>
                Resources to get started
              </h2>
              <p className="mb-5" style={{ fontSize: '1.1rem', lineHeight: '1.6', color: '#333' }}>
                Explore our services and learn how we can help you on your healthcare journey.
              </p>
              <div className="row g-4">
                <div className="col-md-4">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body text-center p-4">
                      <i className="bi bi-calendar-check" style={{ fontSize: '3rem', color: '#0066cc', marginBottom: '1rem' }}></i>
                      <h5 className="card-title mb-3">Contact us</h5>
                      <p className="card-text text-muted mb-3">
                        Schedule your visit with our specialists
                      </p>
                      <Link to="/contact" className="btn btn-outline-primary">
                        Connect to Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body text-center p-4">
                      <i className="bi bi-heart-pulse" style={{ fontSize: '3rem', color: '#0066cc', marginBottom: '1rem' }}></i>
                      <h5 className="card-title mb-3">Find a Doctor</h5>
                      <p className="card-text text-muted mb-3">
                        Browse our team of expert physicians
                      </p>
                      <Link to="/senior-management" className="btn btn-outline-primary">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body text-center p-4">
                      <i className="bi bi-info-circle" style={{ fontSize: '3rem', color: '#0066cc', marginBottom: '1rem' }}></i>
                      <h5 className="card-title mb-3">Learn About Us</h5>
                      <p className="card-text text-muted mb-3">
                        Discover our mission and values
                      </p>
                      <Link to="/about-us/overview" className="btn btn-outline-primary">
                        Explore
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PatientCenteredCare;
